import React, { useEffect, useState, useRef } from 'react';
import { Container, Dropdown, Form, Modal, } from 'react-bootstrap';
import LeftNavbar from '../components/LeftNavbar';
import TopHeader from '../components/TopHeader';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Select from 'react-select';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import makeAnimated from 'react-select/animated';
import axios from 'axios';
import { BASE_URL } from '../components/App';
import { CSVDownload } from 'react-csv';
import { debounce } from 'lodash';
import { useNavigate, Link } from 'react-router-dom';
import { verifyPermission } from '../helpers/roleBasedAccess';
import { FullLoader } from '../components/Loader';

import { useParams } from 'react-router-dom';
import { userRoles } from '../assets/data/userRoles';
import { decryptDataFromArray } from '../helpers/EncryptDecrypt';
import { MonaRoles } from '../constant';
const animatedComponents = makeAnimated();
const training = [{ value: 'sydney', label: 'Sydney', }, { value: 'melbourne', label: 'Melbourne', },];
let DeleteId = [];

function isLoggedInRoleSmaller(detailRole, loggedInRole) {
  let roleObj = [{ id: 1, role_name: 'franchisor_admin', },
  { id: 2, role_name: 'franchisee_admin', },
  { id: 3, role_name: 'coordinator', },
  { id: 4, role_name: 'educator', },
  { id: 5, role_name: 'guardian', }];

  let detailRoleId = roleObj.filter((d) => d.role_name === detailRole);
  detailRoleId = detailRoleId[0].id;

  let loggedInRoleId = roleObj.filter((d) => d.role_name === loggedInRole);
  loggedInRoleId = loggedInRoleId[0].id;

  return parseInt(loggedInRoleId) < parseInt(detailRoleId);
}

const UserManagement = () => {
  const Key = useParams();

  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [userEducator, setEducator] = useState([]);
  const [selectedFranchisee, setSelectedFranchisee] = useState(null);
  const [csvDownloadFlag, setCsvDownloadFlag] = useState(false);
  const [csvUploadFlag, setCsvUploadFlag] = useState(false);
  const [csvExportModalOpen, setCsvExportModalOpen] = useState(false);
  const [exportSelectedRoles, setExportSelectedRoles] = useState({});
  const [exportSelectedStatuses, setExportSelectedStatuses] = useState({
    active: true,
    inactive: false,
  });
  const [exportValidationError, setExportValidationError] = useState('');
  const [csvData, setCsvData] = useState([]);
  const [jsonCSVData, setJsonCSVData] = useState([]);
  const [topSuccessMessage, setTopSuccessMessage] = useState();
  const [filter, setFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('active');
  const [search, setSearch] = useState('');
  const [debounceVal, setDebounceVal] = useState("");
  const [lastSearch, setLastSearch] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [deleteResponse, setDeleteResponse] = useState(null);
  const [fullLoaderStatus, setfullLoaderStatus] = useState(true);
  const [userRoleData, setUserRoleData] = useState(userRoles);
  const [displayRoles, setDisplayRoles] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [currentFranchise, setCurrentFranchise] = useState(null);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState("['id', 'DESC']");
  const fetchRequestId = useRef(0);
  const previousFranchiseRef = useRef(null);

  const [colSortOrder, setColSortOrder] = useState({
    col1: "desc", col2: "", col3: "", col4: ""
  });


  const LSToken = localStorage.getItem('token');
  const AxiosHeaders = { headers: { Authorization: `Bearer ${LSToken}` } }

  const [LSUserRole, setLSUserRole] = useState(localStorage.getItem('user_role'));
  const [LSUserId, setLSUserId] = useState(parseInt(localStorage.getItem('user_id')));


  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.text === 'Deactivate') {
        async function deactivateUserFromDB() {
          const response = await axios.patch(`${BASE_URL}/auth/user/status/${row.userID}`, { is_active: 0, }, AxiosHeaders);

          if (response.status === 201 && response.data.status === 'success') {
            fetchUserDetails();
          }
        }
        if (window.confirm('Are you sure you want to deactivate this user?')) {
          deactivateUserFromDB();
        }
      }

      if (e.target.text === 'Activate') {
        async function activateUserFromDB() {
          const response = await axios.patch(`${BASE_URL}/auth/user/status/${row.userID}`, { is_active: 1, }, AxiosHeaders);

          if (response.status === 201 && response.data.status === 'success') {
            fetchUserDetails();
          }
        }
        if (window.confirm('Are you sure you want to activate this user?')) {
          activateUserFromDB();
        }
      }
      if (e.target.text === 'Edit') {
        navigate(`/edit-user/${row.userID}`);
      }
    },
  };

  const setSortFn = (col, order) => {
    setPage(1); setTotal(0);
    setSort(`['${col}','${order.toUpperCase()}']`);
  }

  const onSortCaret = (col) => {
    if (colSortOrder[col] == "asc") {
      return <span className="react-bootstrap-table-sort-order"><span className="caret"></span></span>
    }
    else {
      return <span className="react-bootstrap-table-sort-order dropup"><span className="caret"></span></span>
    }
  }

  const columns = [
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      sortCaret: (order, column) => { return onSortCaret("col1") },
      onSort: (field, order) => { const o = colSortOrder.col1 == "desc" ? "asc" : "desc"; setColSortOrder({ ...colSortOrder, col1: o }); setSortFn('fullname', o); },
      formatter: (cell) => {
        if (cell) {
          let status = null;
          cell = cell.split(',');
          if (parseInt(cell[3]) === 0) {
            status = 'inactive';
          } else if (parseInt(cell[3]) === 1) {
            status = 'active';
          } else if (parseInt(cell[3]) === 2) {
            status = 'deleted';
          }

          let userId = cell[4].trim();
          let role = cell[2].toLowerCase().trim();
          return (
            <>
              <div className="user-list">
                <span className="user-pic">
                  <img src={cell[0] === 'null' ? '../img/upload.jpg' : cell[0]} alt="" />
                </span>
                <span className="user-name">
                  <Link to={`/profile/${userId}/${role}`}>{cell[1]}</Link>
                  <small>{cell[2]}</small>{' '}
                  <small className={`${status}`}>{status}</small>
                </span>
              </div>
            </>
          );
        }
      },
    },
    {
      dataField: 'email', text: 'Email', sort: true,
      sortCaret: (order, column) => { return onSortCaret("col2") },
      onSort: (field, order) => { const o = colSortOrder.col2 == "desc" ? "asc" : "desc"; setColSortOrder({ ...colSortOrder, col2: o }); setSortFn('email', o); },
    },
    {
      dataField: 'number', text: 'Phone', sort: true,
      sortCaret: (order, column) => { return onSortCaret("col3") },
      onSort: (field, order) => { const o = colSortOrder.col3 == "desc" ? "asc" : "desc"; setColSortOrder({ ...colSortOrder, col3: o }); setSortFn('phone', o); },
    },
    {
      dataField: 'location', text: 'Location', sort: true,
      sortCaret: (order, column) => { return onSortCaret("col4") },
      onSort: (field, order) => { const o = colSortOrder.col4 == "desc" ? "asc" : "desc"; setColSortOrder({ ...colSortOrder, col4: o }); setSortFn('city', o); },
    },
    {
      dataField: 'roleDetail',
      text: 'Action',
      formatter: (cell) => {
        if (cell) {
          cell = cell.split(',');
          return (
            <>
              {(LSUserRole === 'franchisor_admin' || LSUserRole === 'franchisee_admin' || LSUserRole === 'coordinator') && cell[0] === 'guardian' && cell[1] == 0 ? (
                <button className="btn btn-outline-danger" onClick={() => navigate(`/child-enrollment-init/${cell[3]}`)} > New Children </button>
              ) : cell[0] === 'guardian' && cell[1] != 0 ? (
                <button className="btn btn-outline-secondary" onClick={() => navigate(`/children/${cell[3]}`, { state: { franchisee_id: cell[2] }, })} >View Children</button>
              ) : ('')}
            </>
          );
        }
      },
    },
    {
      dataField: 'action',
      text: '',
      formatter: (cell) => {
        if (cell) {
          let button = null;
          cell = cell.split(',');

          if (parseInt(cell[0]) === 1) {
            button = 'Deactivate';
          } else if (parseInt(cell[0]) === 0) {
            button = 'Activate';
          }
          return (
            <>
              <div className="cta-col">
                {isLoggedInRoleSmaller(cell[1], LSUserRole) && (
                  <Dropdown>
                    <Dropdown.Toggle variant="transparent" id="ctacol"> <img src="../img/dot-ico.svg" alt="" /> </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {parseInt(cell[0]) === 1 && LSUserRole != MonaRoles.educator && (<Dropdown.Item href="#">Edit</Dropdown.Item>)}
                      <Dropdown.Item href="#">{button}</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </>
          );
        }
      },
    },
  ];

  const getFormattedName = (name) => {
    let firstName = name?.split(' ')[0];
    let secondName = name?.split(' ')?.slice(1).join(' ');

    return `${firstName}\n${secondName}`;
  };

  const normalizeRoleKey = (role) => (role || '').toLowerCase();

  const getExportRoleOptions = () => {
    if (displayRoles?.length) return displayRoles;
    return userRoleData || [];
  };

  const areAllExportRolesSelected = () => {
    const roles = getExportRoleOptions();
    return roles.length > 0 && roles.every((role) => exportSelectedRoles[role.value]);
  };

  const openExportModal = () => {
    const roleSelections = {};
    getExportRoleOptions().forEach((role) => {
      roleSelections[role.value] = true;
    });
    setExportSelectedRoles(roleSelections);
    setExportSelectedStatuses({ active: true, inactive: false });
    setExportValidationError('');
    setCsvExportModalOpen(true);
  };

  const closeExportModal = () => {
    setCsvExportModalOpen(false);
    setExportValidationError('');
  };

  const handleSelectAllExportRoles = (checked) => {
    const roleSelections = {};
    getExportRoleOptions().forEach((role) => {
      roleSelections[role.value] = checked;
    });
    setExportSelectedRoles(roleSelections);
    setExportValidationError('');
  };

  const toggleExportRole = (roleValue, checked) => {
    setExportSelectedRoles((prev) => ({
      ...prev,
      [roleValue]: checked,
    }));
    setExportValidationError('');
  };

  const toggleExportStatus = (statusKey, checked) => {
    setExportSelectedStatuses((prev) => ({
      ...prev,
      [statusKey]: checked,
    }));
    setExportValidationError('');
  };

  const applyEducatorListRules = (userData, roleFilter = '') => {
    let data = [...userData];

    if (LSUserRole === 'educator') {
      let educatorList = data.filter((user) => user.role === 'educator');
      let nonEducatorList = data.filter((user) => user.role !== 'educator');
      educatorList = educatorList.filter((user) => parseInt(user.id) === LSUserId);
      data = [...educatorList, ...nonEducatorList];
    }

    if (roleFilter === 'Educator' && LSUserRole === 'educator') {
      let educatorList = data.filter((user) => user.role === 'educator');
      educatorList = educatorList.filter((user) => parseInt(user.id) === LSUserId);
      data = [...educatorList];
    }

    if (roleFilter === 'Coordinator' && LSUserRole === 'educator') {
      data = data.filter((user) => user.role === 'coordinator');
    }

    if (roleFilter === 'Guardian' && LSUserRole === 'educator') {
      data = data.filter((user) => user.role === 'guardian');
    }

    return data;
  };

  const filterUsersForExport = (users, roleSelections, statusSelections) => {
    const selectedRoles = Object.entries(roleSelections)
      .filter(([, selected]) => selected)
      .map(([roleValue]) => normalizeRoleKey(roleValue));

    return users.filter((user) => {
      if (user.is_deleted === 1 || Number(user.is_active) === 2) return false;

      const roleMatch = selectedRoles.includes(normalizeRoleKey(user.role));
      const isActive = Number(user.is_active) === 1;
      const isInactive = Number(user.is_active) === 0;

      let statusMatch = false;
      if (statusSelections.active && isActive) statusMatch = true;
      if (statusSelections.inactive && isInactive) statusMatch = true;

      return roleMatch && statusMatch;
    });
  };

  const buildCsvRowsFromUsers = (users) => {
    return users.map((dt) => ({
      name: dt.fullname,
      email: dt.email,
      number: dt.phone !== null ? dt.phone.slice(1) : null,
      location: dt.city,
      role: dt.role
        .split('_')
        .map((d) => d.charAt(0).toUpperCase() + d.slice(1))
        .join(' '),
      status: Number(dt.is_active) === 1 ? 'Active' : 'Inactive',
    }));
  };

  const validateExportSelections = () => {
    const selectedRoleCount = Object.values(exportSelectedRoles).filter(Boolean).length;
    const selectedStatusCount = Object.values(exportSelectedStatuses).filter(Boolean).length;

    if (!selectedRoleCount) {
      return 'Select at least one role to export.';
    }
    if (!selectedStatusCount) {
      return 'Select at least one status (Active and/or Inactive) to export.';
    }
    return '';
  };

  const handleExportCsv = async () => {
    const validationMessage = validateExportSelections();
    if (validationMessage) {
      setExportValidationError(validationMessage);
      return;
    }

    await fetchCsvDetails({
      roles: exportSelectedRoles,
      statuses: exportSelectedStatuses,
    });
  };

  const importCSVToDB = async () => { };

  const csvFileToArray = (csvTextData) => {
    const csvHeader = csvTextData
      .slice(0, csvTextData.indexOf('\n'))
      .split(',');
    const csvRows = csvTextData
      .slice(csvTextData.indexOf('\n') + 1)
      .split('\n');

    let array = csvRows.map((i) => {
      const values = i.split(',');
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index];
        return object;
      }, {});
      return obj;
    });

    array = array.map((d) => {
      return {
        address: d.address,
        city: d.city,
        crn: d.city,
        email: d.email,
        franchisee_id: d.franchisee_id,
        fullname: d.fullname,
        postalCode: d.postalCode,
        role: d.role,
        state: d.state,
        phone: `+61-${d.phone}`,
      };
    });

    array = array.slice(0, array.length - 1);
    setJsonCSVData(array);
  };

  const handleCSVImport = (e) => {
    e.preventDefault();

    setCsvUploadFlag(false);
    const fileReader = new FileReader();
    if (csvData) {
      fileReader.onload = function (event) {
        const csvOutput = event.target.result;
        csvFileToArray(csvOutput);
      };

      fileReader.readAsText(csvData);
    }
  };

  const handleCSVFileSave = (e) => {
    setCsvData(null);
    setCsvData(e.target.files[0]);
  };

  const resolveFranchiseId = () => {
    const franchiseId = currentFranchise || selectedFranchisee || localStorage.getItem('selectedFranchise') || 'all';
    if (!franchiseId || franchiseId === 'undefined') return 'all';
    if (franchiseId === 'All') return 'all';
    return franchiseId;
  };

  const mapUsersToTableRows = (users = []) =>
    users.map((dt) => ({
      name: `${dt.profile_photo}, ${getFormattedName(dt.fullname)}, ${dt.role
        .split('_')
        .map((d) => d.charAt(0).toUpperCase() + d.slice(1))
        .join(' ')}, ${dt.is_active}, ${dt.id}`,
      email: dt.email,
      number: dt.phone !== null ? dt.phone.slice(1) : null,
      location: dt.city,
      role: dt.role,
      is_deleted: dt.is_deleted,
      userID: dt.id,
      roleDetail:
        dt.role +
        ',' +
        dt.isChildEnrolled +
        ',' +
        dt.franchisee_id +
        ',' +
        dt.id,
      action: `${dt.is_active},${dt.role}`,
    }));

  const fetchUserDetails = async (overrides = {}) => {
    const franchiseId = resolveFranchiseId();
    if (!franchiseId) return;

    const currentPage = overrides.page ?? page;
    const currentLimit = overrides.limit ?? limit;
    const offset = (currentPage - 1) * currentLimit;
    const appliedFilter = overrides.filter !== undefined ? overrides.filter : filter;
    const appliedStatusFilter =
      overrides.statusFilter !== undefined ? overrides.statusFilter : statusFilter;
    const appliedSearch = overrides.search !== undefined ? overrides.search : search;

    const requestId = ++fetchRequestId.current;
    const isInitialLoad = userData.length === 0;
    const shouldShowLoader =
      isInitialLoad || !!overrides.showLoader || fullLoaderStatus;
    if (shouldShowLoader) {
      setfullLoaderStatus(true);
    }
    setLoading(true);

    const api_url = `${BASE_URL}/role/user/list/${franchiseId}?search=${appliedSearch}&filter=${appliedFilter}&statusFilter=${appliedStatusFilter}&offset=${offset}&limit=${currentLimit}&sort=${sort}&userrole=${LSUserRole}&userid=${LSUserId}`;

    try {
      const response = await axios.get(api_url, AxiosHeaders);
      if (requestId !== fetchRequestId.current) return;

      const responseData = decryptDataFromArray(response?.data);

      if (responseData.status === 'success') {
        setTotal(responseData.count);
        setUserData(mapUsersToTableRows(responseData.users || []));
        setLastSearch(appliedSearch);
        setIsLoading(false);
      }
    } finally {
      if (requestId === fetchRequestId.current) {
        if (shouldShowLoader) {
          setfullLoaderStatus(false);
        }
        setLoading(false);
      }
    }
  };

  const fetchCsvDetails = async (exportOptions) => {
    if (!exportOptions || !currentFranchise) return;

    const { roles, statuses } = exportOptions;

    if (!loading && currentFranchise) {
      setfullLoaderStatus(true);
      setLoading((x) => !x);

      const api_url = `${BASE_URL}/role/user/list/${currentFranchise}?search=&filter=&statusFilter=all&offset=0&limit=99999&sort=${sort}&userrole=${LSUserRole}&userid=${LSUserId}`;

      try {
        const response = await axios.get(api_url, AxiosHeaders);
        const responseData = decryptDataFromArray(response?.data);

        if (responseData.status === 'success') {
          let userData = applyEducatorListRules(responseData.users || [], '');
          userData = filterUsersForExport(userData, roles, statuses);

          if (!userData.length) {
            setExportValidationError('No users match the selected export filters.');
            return;
          }

          setCsvData(buildCsvRowsFromUsers(userData));
          setCsvExportModalOpen(false);
          setExportValidationError('');
          setCsvDownloadFlag(true);
        }
      } catch (error) {
        setExportValidationError('Unable to export users. Please try again.');
      } finally {
        setfullLoaderStatus(false);
        setLoading((x) => !x);
      }
    }
  };




  const Show_eduactor = async () => {
    let api_url = '';
    let filter = Key.key;
    let id =
      LSUserRole === 'guardian'
        ? localStorage.getItem('franchisee_id')
        : selectedFranchisee;
    if (filter) {
            api_url = `${BASE_URL}/role/user/list/${selectedFranchisee}?search=${search}&filter=${filter}&statusFilter=${statusFilter}`;
    }
    if (api_url) {
      let response = await axios.get(api_url, AxiosHeaders);

      if (response) {
        setfullLoaderStatus(false);
      }
      let responseData = decryptDataFromArray(response?.data);

      if (responseData.status === 'success') {
        const { users } = responseData || {};
        let tempData = users.map((dt) => ({
          name: `${dt.profile_photo}, ${getFormattedName(dt.fullname)}, ${dt.role
            .split('_')
            .map((d) => d.charAt(0).toUpperCase() + d.slice(1))
            .join(' ')}, ${dt.is_active}, ${dt.id}`,
          email: dt.email,
          number: dt.phone !== null ? dt.phone.slice(1) : null,
          location: dt.city,
          role: dt.role,
          is_deleted: dt.is_deleted,
          userID: dt.id,
          roleDetail:
            dt.role +
            ',' +
            dt.isChildEnrolled +
            ',' +
            dt.franchisee_id +
            ',' +
            dt.id,
          action: `${dt.is_active},${dt.role}`,
        }));
        setEducator(tempData);
        setIsLoading(false);

        let temp = tempData;
        let csv_data = [];
        temp.map((item, index) => {
          delete item.is_deleted;
          csv_data.push(item);
          let data = { ...csv_data[index] };
          data['name'] = data.name.split(',')[1];
          delete data.action;
          delete data.roleDetail;
          csv_data[index] = data;
        });
        setCsvData(csv_data);
      }
    }
  };
  useEffect(() => {
    if (Key) {
      Show_eduactor();
    }
  }, [selectedFranchisee]);

  const handleApplyFilter = async () => {
    setPage(1);
    if (openFilter === true) {
      setOpenFilter(false);
    }
    fetchUserDetails({ page: 1 });
  };

  const handleResetFilters = () => {
    setFilter('');
    setStatusFilter('active');
    setPage(1);
    if (openFilter === true) {
      setOpenFilter(false);
    }
    fetchUserDetails({ page: 1, filter: '', statusFilter: 'active' });
  };

  const trimRoleList = () => {
    let currentRole = LSUserRole;
    let newRoleList = userRoleData;

    if (currentRole === 'educator') {
      newRoleList = newRoleList.filter((role) => role.id > 2);
      setDisplayRoles(newRoleList);
    }

    if (currentRole === 'coordinator') {
      newRoleList = newRoleList.filter((role) => role.id > 1);
      setDisplayRoles(newRoleList);
    }

    if (currentRole === 'franchisee_admin') {
      newRoleList = newRoleList.filter((role) => role);
      setDisplayRoles(newRoleList);
    }

    if (currentRole === 'franchisor_admin') {
      newRoleList = newRoleList.filter((role) => role);
      setDisplayRoles(newRoleList);
    }

    if (currentRole === 'guardian') {
      newRoleList = newRoleList.filter((role) => role.id === 5);
      setDisplayRoles(newRoleList);
    }
  };


  useEffect(() => {
    if (!selectedFranchisee) return;
    const normalized = selectedFranchisee === 'All' ? 'all' : selectedFranchisee;
    setfullLoaderStatus(true);
    setCurrentFranchise(normalized);
    setPage(1);
  }, [selectedFranchisee]);

  useEffect(() => {
    if (deleteResponse !== null) fetchUserDetails();
  }, [deleteResponse]);

  useEffect(() => {
    if (!filter) {
      setPage(1);
    }
  }, [filter]);

  useEffect(() => {
    setCsvData(null);
    let a = localStorage.getItem('success_msg');
    if (a) {
      setTopSuccessMessage(a);
      localStorage.removeItem('success_msg');

      setTimeout(() => {
        setTopSuccessMessage(null);
      }, 3000);
    }
    if (LSUserRole === 'guardian') {
      window.location.href = `/parents-dashboard`;
    }
  }, []);
  useEffect(() => {
    trimRoleList();
  }, [userRoleData]);

  useEffect(() => {
    if (csvDownloadFlag) {
      const timer = setTimeout(() => setCsvDownloadFlag(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [csvDownloadFlag]);

  useEffect(() => {
    importCSVToDB();
  }, [jsonCSVData]);

  useEffect(() => {
    const storedFranchise = localStorage.getItem('selectedFranchise');
    if (storedFranchise) {
      setCurrentFranchise(storedFranchise === 'All' ? 'all' : storedFranchise);
    }
  }, []);

  const csvLink = useRef();

  useEffect(() => {
    if (!currentFranchise) return;
    const isFranchiseChanged = previousFranchiseRef.current !== currentFranchise;
    previousFranchiseRef.current = currentFranchise;
    fetchUserDetails({ search: debounceVal, showLoader: isFranchiseChanged });
  }, [page, limit, sort, currentFranchise]);

  useEffect(() => {
    if (!currentFranchise) return;
    if (page !== 1) {
      setPage(1);
      return;
    }
    fetchUserDetails({ page: 1, search: debounceVal });
  }, [debounceVal]);

  const defaultSortedBy = [{
    dataField: "name",
    order: "desc"  // or desc
  }];

  const handleTableChange = (type, { page: nextPage, sizePerPage: nextSizePerPage }) => {
    if (type === 'pagination') {
      if (nextSizePerPage !== limit) {
        setLimit(nextSizePerPage);
      }
      if (nextPage !== page) {
        setPage(nextPage);
      }
    }
  };

  const getOption = (tot) => {
    const options = {
      page,
      totalSize: tot,
      showTotal: true,
      withFirstAndLast: false,
      alwaysShowAllBtns: true,
      sizePerPage: limit,
      onPageChange: (pg) => {
        if (page !== pg) {
          setPage(pg);
        }
      },
      onSizePerPageChange: (sizePerPage) => {
        if (limit !== sizePerPage) {
          setPage(1);
          setLimit(sizePerPage);
        }
      },
    };
    return options;
  }




  const debounceValue = useDebounce(search, 1200);

  useEffect(() => {
    setDebounceVal(search);
  }, [debounceValue]);

  const getSearchBar = () => {
    return (
      <Form.Control className="searchBox" type="text" placeholder="Search" name="search"
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
    )
  }




  return (
    <>
      <div id="main" className="main-class">
        <section className="mainsection">
          <Container>
            <div className="admin-wrapper">
              <aside className="app-sidebar"> <LeftNavbar /> </aside>
              <div className="sec-column">
                <TopHeader setSelectedFranchisee={setSelectedFranchisee} />
                <FullLoader loading={fullLoaderStatus} />

                <div className="entry-container">
                  <div className="user-management-sec">
                    <>
                      {topSuccessMessage && (
                        <p className="alert alert-success" style={{ position: 'fixed', left: '50%', top: '0%', zIndex: 1000, }} > {topSuccessMessage} </p>
                      )}
                      <header className="title-head">
                        <h1 className="title-lg">All User</h1>
                        <div className="othpanel">
                          <div className="extra-btn">
                            <div className="data-search me-3">
                              <Form.Group className="d-flex" style={{ position: 'relative' }} >
                                <div className="user-search"> <img src="./img/search-icon-light.svg" alt="" /> </div>
                                
                                {getSearchBar()}
                              </Form.Group>
                            </div>
                            <Dropdown className="filtercol me-3">
                              <Dropdown.Toggle id="extrabtn" variant="btn-outline" onClickCapture={() => { if (openFilter === false) setOpenFilter(true); }} >
                                <i className="filter-ico"></i> Add Filters
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <header>Filter by</header>
                                <div className="custom-radio btn-radio mb-2"> <label style={{ marginBottom: '5px' }}> Role </label>
                                  <Form.Group className="filter_radio">
                                    {displayRoles &&
                                      displayRoles.map((role, index) => {
                                        return (
                                          <Form.Check key={index} inline label={role.label} value={role.value} name="users" type="radio" className="filter_radio"
                                            id={`${role.value}-${index}`}
                                            checked={filter === `${role.value}`}
                                            onChange={(event) => {
                                              setFilter(event.target.value);
                                            }}
                                          />
                                        );
                                      })}
                                  </Form.Group>
                                </div>
                                <div className="custom-radio btn-radio mb-2">
                                  <label style={{ marginBottom: '5px' }}> Status </label>
                                  <Form.Group className="filter_radio">
                                    <Form.Check
                                      inline
                                      label="Active"
                                      value="active"
                                      name="status"
                                      type="radio"
                                      className="filter_radio"
                                      id="status-active"
                                      checked={statusFilter === 'active'}
                                      onChange={(event) => setStatusFilter(event.target.value)}
                                    />
                                    <Form.Check
                                      inline
                                      label="Inactive"
                                      value="inactive"
                                      name="status"
                                      type="radio"
                                      className="filter_radio"
                                      id="status-inactive"
                                      checked={statusFilter === 'inactive'}
                                      onChange={(event) => setStatusFilter(event.target.value)}
                                    />
                                    <Form.Check
                                      inline
                                      label="All"
                                      value="all"
                                      name="status"
                                      type="radio"
                                      className="filter_radio"
                                      id="status-all"
                                      checked={statusFilter === 'all'}
                                      onChange={(event) => setStatusFilter(event.target.value)}
                                    />
                                  </Form.Group>
                                </div>
                                <footer>
                                  <Dropdown.Item as="button" className="btn btn-transparent w-auto d-inline-block" type="submit"
                                    onClick={handleResetFilters}
                                  > Reset </Dropdown.Item>
                                  <Dropdown.Item as="button" className="btn btn-primary w-auto d-inline-block" type="submit"
                                    onClickCapture={() => { handleApplyFilter(); }} > Apply </Dropdown.Item>
                                </footer>
                              </Dropdown.Menu>
                            </Dropdown>
                            {verifyPermission('user_management', 'add') && (
                              <Link to="/new-user" className="btn btn-primary me-3" > + Create New User </Link>
                            )}
                            <Dropdown>
                              <Dropdown.Toggle id="extrabtn" className="ctaact">
                                <img src="../img/dot-ico.svg" alt="" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={openExportModal}> Export CSV </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </header>

                      {(!Key.key ? userData : userEducator).length > 0 &&
                        <ToolkitProvider keyField="name" data={!Key.key ? userData : userEducator} columns={columns}>
                          {(props) => (
                            <BootstrapTable
                              remote={{ pagination: true }}
                              {...props.baseProps}
                              rowEvents={rowEvents}
                              onTableChange={handleTableChange}
                              pagination={paginationFactory(getOption(total))}
                            />)}
                        </ToolkitProvider>
                      }

                      {!fullLoaderStatus && userData.length === 0 && total === 0 &&
                        <p>No match found!</p>
                      }
                    </>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
      {csvDownloadFlag && csvData && (
        <CSVDownload
          data={csvData}
          filename="user_management.csv"
          ref={csvLink}
          target="_blank"
        />
      )}
      {csvExportModalOpen && (
        <Modal
          show={csvExportModalOpen}
          onHide={closeExportModal}
          centered
          dialogClassName="user-export-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Export Users to CSV</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="export-modal-intro">
              Choose which roles and statuses to include in the export.
            </p>

            {exportValidationError && (
              <div className="alert alert-danger py-2 mb-3">{exportValidationError}</div>
            )}

            <div className="export-modal-section">
              <h6 className="export-modal-section-title mb-3">Roles</h6>
              <div className="export-role-grid">
                {getExportRoleOptions().map((role, index) => (
                  <div className="btn-checkbox" key={role.value}>
                    <Form.Check
                      type="checkbox"
                      id={`export-role-${index}`}
                      className="p-0"
                      label={role.label}
                      checked={!!exportSelectedRoles[role.value]}
                      onChange={(e) => toggleExportRole(role.value, e.target.checked)}
                    />
                  </div>
                ))}
              </div>
              <div className="btn-checkbox export-select-all mt-3">
                <Form.Check
                  type="checkbox"
                  id="export-select-all-roles"
                  className="p-0"
                  label="Select All"
                  checked={areAllExportRolesSelected()}
                  onChange={(e) => handleSelectAllExportRoles(e.target.checked)}
                />
              </div>
            </div>

            <div className="export-modal-section">
              <h6 className="export-modal-section-title mb-3">Status</h6>
              <div className="export-status-row">
                <div className="btn-checkbox">
                  <Form.Check
                    type="checkbox"
                    id="export-status-active"
                    className="p-0"
                    label="Active"
                    checked={exportSelectedStatuses.active}
                    onChange={(e) => toggleExportStatus('active', e.target.checked)}
                  />
                </div>
                <div className="btn-checkbox">
                  <Form.Check
                    type="checkbox"
                    id="export-status-inactive"
                    className="p-0"
                    label="Inactive"
                    checked={exportSelectedStatuses.inactive}
                    onChange={(e) => toggleExportStatus('inactive', e.target.checked)}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-transparent" onClick={closeExportModal}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleExportCsv}>
              Export CSV
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {csvUploadFlag && (
        <Modal show={csvUploadFlag} onHide={() => setCsvUploadFlag(false)}>
          <Modal.Header>
            <Modal.Title>Upload User Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p> Choose a CSV file you want to extract and import the user data from. </p>
              <form> <input type={'file'} accept={'.csv'} onChange={handleCSVFileSave} /> </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="modal-button" onClick={handleCSVImport}> Import CSV </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

function useDebounce(cb, delay) {
  const [debounceValue, setDebounceValue] = useState(cb);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(cb);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [cb, delay]);
  return debounceValue;
}

export default UserManagement;
